import "@/App.css";
import "@/riwis.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import PhonesPage from "@/pages/PhonesPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPage from "@/pages/AdminPage";
import OfflinePage from "@/pages/OfflinePage";

const SITE_OFFLINE = process.env.REACT_APP_SITE_OFFLINE === "true";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="page-loading">Laden...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  if (SITE_OFFLINE) return <OfflinePage />;
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/telefoonnummers" element={<PhonesPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
